<template>
  <iModal
    :visible="isCreateCourseModalOpen"
    :max-width="500"
    title="Create Course"
    primary-action-button-label="Create"
    :primary-action-button-loading="isCreatingCourse"
    :primary-action-button-disabled="!isFormValid"
    :show-footer-divider="false"
    @close="closeModal"
    @click:primary="submitCourse"
    @click:secondary="closeModal"
  >
    <template #body>
      <iColumn>
        <iRow>
          <iTextInput
            v-model="courseName"
            placeholder="What is the name of your course?"
            label="Name"
            required
            width="fill"
          />
        </iRow>
        <iRow>
          <iTextInput
            v-model="coursePrice"
            type="number"
            placeholder="How much will your course cost?"
            label="Price"
            :padding-left-multiplier="2"
            required
            width="fill"
          >
            <template #prepend>
              $
            </template>
          </iTextInput>
        </iRow>
        <iRow>
          <iTextInput
            v-model="numberOfLessons"
            type="number"
            placeholder="How many lessons will your course have?"
            label="Number of Lessons"
            required
            width="fill"
            @enter="submitCourse"
          />
        </iRow>
      </iColumn>
    </template>
  </iModal>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useCourseStore } from "@/stores/course-store";
import { usePublicationStore } from "@/stores/publication-store";

export default {
  name: "CreateCourse",
  data() {
    return {
      courseName: "",
      coursePrice: "",
      numberOfLessons: "",
    };
  },
  computed: {
    ...mapState(useCourseStore, [
      "isCreateCourseModalOpen",
      "isCreatingCourse",
    ]),
    ...mapState(usePublicationStore, ["publicationId"]),
    isFormValid() {
      return (
        this.courseName && this.coursePrice >= 0 && this.numberOfLessons >= 0
      );
    },
  },
  methods: {
    ...mapActions(useCourseStore, ["closeCreateCourseModal", "createCourse"]),
    closeModal() {
      this.courseName = "";
      this.coursePrice = "";
      this.numberOfLessons = "";
      this.closeCreateCourseModal();
    },
    submitCourse() {
      if (!this.isFormValid) {
        return;
      }
      this.createCourse(
        this.courseName,
        this.publicationId,
        this.coursePrice,
        this.numberOfLessons,
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
